import {
  Mic,
  Type,
  MessageSquare,
  Volume2,
  Zap,
  Target,
  Brain,
} from "lucide-react";

export const inputModeFeatures = [
  {
    icon: <Mic className="w-6 h-6" />,
    label: "Voice Only",
    shortLabel: "Voice",
    description:
      "Speak directly to the AI using your microphone. No text input field will be available. Perfect for hands-free interaction.",
    highlight: "Hands-free",
  },
  {
    icon: <Type className="w-6 h-6" />,
    label: "Text Only",
    shortLabel: "Text",
    description:
      "Type your messages using the keyboard. Microphone will be disabled. Ideal for quiet environments or when voice input isn't available.",
    highlight: "Silent mode",
  },
  {
    icon: <MessageSquare className="w-6 h-6" />,
    label: "Voice + Text",
    shortLabel: "Both",
    description:
      "Use both voice and text input methods. Switch between typing and speaking as needed for maximum flexibility.",
    highlight: "Ultimate flexibility",
  },
];

export const responseModeFeatures = [
  {
    icon: <Type className="w-6 h-6" />,
    label: "Text Only",
    shortLabel: "Text",
    description:
      "AI responses will appear as text messages only. Silent operation - perfect for quiet environments or when audio output isn't desired.",
    highlight: "Silent feedback",
  },
  {
    icon: <Volume2 className="w-6 h-6" />,
    label: "Text + Voice",
    shortLabel: "Text + Voice",
    description:
      "AI responses will be displayed as text and also spoken aloud using text-to-speech. Great for accessibility and multitasking scenarios.",
    highlight: "Spoken responses",
  },
];

export const keyBenefits = [
  {
    icon: <Brain className="w-5 h-5" />,
    title: "Realistic Interview Questions",
    description:
      "Get access to actual visa interview questions tailored to your visa type",
  },
  {
    icon: <Target className="w-5 h-5" />,
    title: "Instant Feedback",
    description:
      "Receive detailed feedback on your responses, helping you identify areas for improvement.",
  },
  {
    icon: <Zap className="w-5 h-5" />,
    title: "Boost Confidence",
    description:
      "Reduce anxiety by familiarizing yourself with the interview process. ",
  },
];
